import { Modal } from '@bp/ui-components';
import { useTranslation } from 'react-i18next';
import { HolidaysForm } from '../../Holidays/Form/HolidaysForm';
import { HolidayType } from '../../Holidays/graphql';

type HolidayFormModalProps = {
  isOpen: boolean;
  /** `null` legt neue Ferien an */
  holiday: HolidayType | null;
  onClose: () => void;
};

/** Ferien anlegen oder bearbeiten; genutzt von der Ferienleiste und dem Button im Kopf der Zeitleiste. */
export const HolidayFormModal = ({ isOpen, holiday, onClose }: HolidayFormModalProps) => {
  const { t } = useTranslation();

  return (
    <Modal
      isOpen={isOpen}
      onRequestClose={onClose}
      shouldCloseOnEsc={false}
      shouldCloseOnOverlayClick={false}
      title={holiday ? t('holidays.edit') : t('holidays.add')}
    >
      <HolidaysForm holiday={holiday} handleClose={onClose} />
    </Modal>
  );
};
